/**
 * AdPrimus Accordion
 * Vanilla JS accordion with smooth height animation.
 * Works with [data-ap-accordion] container and [data-ap-accordion-trigger] buttons.
 */
(function () {
  'use strict';

  function initAccordion(container) {
    var triggers = container.querySelectorAll('[data-ap-accordion-trigger]');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-ap-accordion-item]');
        var content = item.querySelector('[data-ap-accordion-content]');
        var isOpen = item.getAttribute('data-state') === 'open';

        // Close all other items if single mode
        if (container.getAttribute('data-ap-accordion-type') === 'single') {
          container.querySelectorAll('[data-ap-accordion-item]').forEach(function (otherItem) {
            if (otherItem !== item && otherItem.getAttribute('data-state') === 'open') {
              closeItem(otherItem);
            }
          });
        }

        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });
  }

  function openItem(item) {
    var content = item.querySelector('[data-ap-accordion-content]');
    var inner = content.querySelector('[data-ap-accordion-inner]');
    item.setAttribute('data-state', 'open');
    content.style.height = '0px';
    content.style.overflow = 'hidden';
    content.style.display = 'block';
    var targetHeight = inner.offsetHeight;
    content.style.transition = 'height 0.2s ease-out';
    requestAnimationFrame(function () {
      content.style.height = targetHeight + 'px';
    });
    content.addEventListener('transitionend', function handler() {
      content.style.height = 'auto';
      content.style.overflow = '';
      content.removeEventListener('transitionend', handler);
    });
  }

  function closeItem(item) {
    var content = item.querySelector('[data-ap-accordion-content]');
    var currentHeight = content.offsetHeight;
    item.setAttribute('data-state', 'closed');
    content.style.height = currentHeight + 'px';
    content.style.overflow = 'hidden';
    content.style.transition = 'height 0.2s ease-out';
    requestAnimationFrame(function () {
      content.style.height = '0px';
    });
    content.addEventListener('transitionend', function handler() {
      content.style.display = 'none';
      content.style.height = '';
      content.style.overflow = '';
      content.removeEventListener('transitionend', handler);
    });
  }

  function init() {
    document.querySelectorAll('[data-ap-accordion]').forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
